module.exports = __webpack_public_path__ + "img/logo.a37bb2c3.svg";